<template>
  <div class="ma-6 quickview-wrapper">

    <v-sheet
      v-if      = "isIdle" 
      class     = "py-4"
      rounded
    >
      <Wizard 
        icon      = "mdi-file-video" 
        class     = "py-8"
      >
        <span class="text-h6">Select media to preview</span>
      </Wizard>
    </v-sheet>

    <v-sheet
      v-if      = "!isIdle"
      class     = "header pa-2"
      rounded
    >
      <span class="path text-h6"><bdi>{{ path }}</bdi></span>

      <v-btn 
        color   = "primary" 
        @click  = "$emit('input', path)"
      >
        Open
      </v-btn>
    </v-sheet>

    <video 
      class       = "my-4"
      v-show      = "!isIdle" 
      ref         = "video" 
      controls 
      autoplay 
      loop 
      crossorigin = "use-credentials"
    >
    </video>

    <v-sheet
      v-if      = "!isIdle"
      class     = "properties"
      rounded
    >
      <PropertiesPane 
        class       = "inspector"
        :properties = "properties"
        :path       = "quickview.path"
      >
      </PropertiesPane>
    </v-sheet>

  </div>
</template>

<script>

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { ATTACH_QUICKVIEW_ELEMENT } from '@/utils/action-types';
import Wizard from '../../panes/components/Wizard';
import PropertiesPane from '../../panes/PropertiesPane';

// #endregion Imports

export default {
  // #region Properties

  name:     'QuickView',
  computed: {
    ...mapState(['quickview']),
    path() {
      return this.quickview.path;
    },
    properties() {
      return this.quickview.controller ? this.quickview.controller.mediaProperties : undefined;
    },
    status() {
      return this.quickview.status;
    },
    isIdle() {
      return this.status === 'idle';
    },
  },
  components: {
    Wizard,
    PropertiesPane
  },

  // #endregion Properties

  // #region Life-Cycle

  mounted() {
    this.$store.dispatch(ATTACH_QUICKVIEW_ELEMENT, this.$refs.video);
  },

  // #endregion Life-Cycle
};

</script>

<style lang="scss" scoped>

.quickview-wrapper {
  height:         100%;

  display:        flex;
  flex-direction: column;
  max-width:      1300px;

  .header {
    display:        flex;
    flex-direction: row;
    align-items:    center;

    .path {
      flex:           1;
      width:          0px;
      padding-right:  16px;

      white-space:    nowrap;
      overflow:       hidden;
      text-overflow:  ellipsis;

      direction:      rtl;
      text-align:     left;
    }
  }

  video {
    width:          100%;
  }

  .properties {
    flex:           1;
    .inspector {
      height:         100%;
    }
  }
}

</style>
